export default "__VITE_ASSET__c49a0822__"